import React from 'react';
import { Box } from '@material-ui/core';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { BLACK_FONT_COLOR, FONT_FAMILY_REGULAR, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX } from '../../../../../styles/fonts/MCFontConstants';

const MpxrConfirmationCard = ({
    isConfirmationCheckboxChecked,
    setIsConfirmationCheckboxChecked,
}) => {
    const { t } = useTranslation();
    return (
        <Box
            bgcolor={isConfirmationCheckboxChecked ? '#FFFFFF' : '#FFF5E4'}
            boxShadow={'0px 0px 6px #00000029'}
            borderRadius={'6px'}
            height={window.innerWidth <= sizes.mobileDevice ? '77px' : '60px'}
            display={'flex'}
            alignItems={'center'}
            padding={'0 13px'}
            position={'relative'}
            marginTop={'10px'}
        >
            <Checkbox
                checked={isConfirmationCheckboxChecked}
                labelStyleObj={{
                    fontFamily: FONT_FAMILY_REGULAR,
                    textAlign: 'left',
                    fontSize: SMALL_TEXT_PX,
                    letterSpacing: '-0.11px',
                    color: BLACK_FONT_COLOR,
                    opacity: 1,
                    paddingLeft: SEMANTIC_TEXT_SMALL_PX,
                    lineHeight:
                        window.innerWidth <= sizes.mobileDevice && '20px',
                }}
                onCheckboxSelectionChange={(e) =>
                    setIsConfirmationCheckboxChecked(e.target.checked)
                }
                id={'confirmationCB'}
                label={t(
                    'reportUsage.procedure.unidSurgery.mPXRConfirmationCard.mPXRcomplaint'
                )}
                checkboxBorder={`${
                    isConfirmationCheckboxChecked ? 'none' : '2px solid #000000'
                } !important`}
                checkedBgColor={'#1010EB'}
                background={!isConfirmationCheckboxChecked && '#FFF5E4'}
            />
        </Box>
    );
};

export default MpxrConfirmationCard;
